import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class DraftSecretSettingModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
      is_send: false,
      is_create: false,
      copy_mode: null,
      is_pass_view: false,
    };
  }
  // -------------------------------------------------------
  
  change() {
    this.setState({ is_send: (this.secret_password.value != '') });
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  toggleCreate(flg) {
    this.setState({ is_create: flg });
  }
  // -------------------------------------------------------
  
  togglePassView(flg) {
    this.setState({ is_pass_view: flg });
  }
  // -------------------------------------------------------
  
  sendPassword(draft_id, mode) {
    let data = this.props.data;
    let item = this.props.item;
    
    let is_change = (item.secret_code != null);
    
    Utils.request.bind(this)('/api/draft/secret_setting', { draft_id: data.draft.id, insta_user_id: data.influencer.insta_user_id, flow_id: this.props.item.id, password: this.secret_password.value, is_send_action: this.is_send_action.value },
      function(res){
        this.secret_password.value = '';
        this.props.refresh_ev.bind(this)(this.props.detail_id);
        
        this.setState({ is_create: false });
        if( is_change == true ) alert('共有URLのリンクとパスワードを更新しました！');
      }.bind(this),
    );
  }
  // -------------------------------------------------------
  
  copy(copy_url) {
    let project = this.props.data.project;
    
    // メッセージコピー
    var textarea = document.getElementById('copy_zone');
    textarea.value = copy_url;
    textarea.select();
    document.execCommand('copy');
    
    this.setState({ copy_mode: 'active' });
    setTimeout( function(){ this.setState({ copy_mode: 'deactive' }); }.bind(this), 1000);
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let item = this.props.item;
    
    let open_url = 'https://casting-space.moribus.jp/draft/secret/'+ item.secret_code;
    let is_active = (item.secret_code != null) ? 'active' : '';
    
    if( this.props.is_secret_mode === true ) return null;
    
    return (
      <div className="draft-secret-setting-modal">
        
        { (this.props.is_guest_mode == true)
          ? <div className={'guest-secret '+ is_active} onClick={this.toggleModal.bind(this, true)}><i className="material-icons">vpn_lock</i>下書き確認の共有URLの発行</div>
          : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>下書きを共有で確認できる状態に変更する</Tooltip>}>
              <div className={'material-icons icon '+ is_active} onClick={this.toggleModal.bind(this, true)}>vpn_lock</div>
            </OverlayTrigger>
        }
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {'calc(100% - 200px)'}
          height    = {510}
          max_width = {800}
          close_ev  = {this.toggleModal.bind(this, false)}
          html      = {
            <div>
              <h1>下書き共有設定</h1>
              <h5>CastingSpaceのアカウントを保持していないユーザーと下書きのやり取りを行えます</h5>
              
              <div className={'open-box '+ is_active}>
                <h3>共有URL</h3>
                { (item.secret_code != null)
                  ? <a href={open_url} target="_blank">{open_url}</a>
                  : <p>未設定</p>
                }
                
                { (item.secret_code != null) && <div className="copy" onClick={this.copy.bind(this, open_url)}>コピー</div> }
                
                { (item.secret_password != null) && <div className="password">パスワード： {(this.state.is_pass_view == false) ? <span onClick={this.togglePassView.bind(this, true)}>表示</span> : item.secret_password}</div>}
              </div>
              
              { (this.state.is_create == false)
                ? <div className="create-box-button">
                    <div className="button" onClick={this.toggleCreate.bind(this, true)}>共有URLを作成する</div>
                  </div>
                : <div className="create-box">
                    <h3>共有URLの作成</h3>
                    
                    <div className="form-box">
                      <div className="form-item">
                        <h6>下書きを編集するためのパスワードを入力してください</h6>
                        <input className="text" type="text" ref={(input) => { this.secret_password = input }} onChange={this.change.bind(this)} placeholder={'パスワード'} />
                      </div>
                      
                      <div className="form-item">
                        <h6>確認結果を報告できる状態にしますか？</h6>
                        <div className="selectbox">
                          <select ref={(input) => { this.is_send_action = input }} onChange={this.change.bind(this)}>
                            <option value="false">次の担当者に確認結果を報告できない</option>
                            <option value="true">次の担当者に確認結果を報告できる</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    
                    { (this.state.is_send == true)
                      ? <div className="button on" onClick={this.sendPassword.bind(this)}>登録</div>
                      : <div className="button off">登録</div>
                    }
                  </div>
              }
              
              <h6 className="hosoku">※本機能は、下書きの確認/修正のみ行える状態をパスワード付きで公開する機能になります。ログインや内部データは閲覧できませんのご安心ください。</h6>
              
              <textarea className="none" id="copy_zone" />
              <p className={'clip-copy '+ this.state.copy_mode}>URLをコピーしました！</p>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftSecretSettingModal;